import type { QueryKey } from '$lib/api/tanstack-query';

const base = ['package'] as const;
const listBase = [...base, 'list'] as const;

export const packageKeys = {
  get: (packageID: string | undefined) => [...base, { packageID }],
  list: (organizationID: string | undefined) => [
    ...listBase,
    { organizationID },
  ],
  listByRegistryItem: (itemID?: string) => [...base, { itemID }],
};

export interface KeyFilters {
  packageID?: string;
  organizationID?: string;
  allLists?: boolean;
  all?: boolean;
  itemID?: string;
}

/** Returns a list of relevant package query keys. Useful for invalidation. */
export const getPackageQueryKeys = ({
  packageID,
  organizationID,
  allLists,
  all,
  itemID,
}: KeyFilters): readonly QueryKey[] => {
  const queryKeys = [];

  if (all) {
    return [base];
  }

  if (packageID !== undefined) {
    queryKeys.push(packageKeys.get(packageID));
  }

  if (allLists) {
    queryKeys.push(listBase);
  } else if (organizationID !== undefined) {
    queryKeys.push(packageKeys.list(organizationID));
  }

  if (itemID) {
    queryKeys.push(packageKeys.listByRegistryItem(itemID));
  }

  return queryKeys;
};
